import React, {memo} from 'react'

import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'

import PipelineSecret from './PipelineSecret/PipelineSecret'
import PipelineSecretForm from './PipelineSecretForm/PipelineSecretForm'
import usePipelineSecrets from './PipelineSecrets.hooks'

function PipelineSecrets() {
  const {
    handlerApplySecretButtonClick,
    handlerCloseSecretButtonClick,
    handlerAddSecretButtonClick,
    isShowPipelineSecretForm,
    settingsBlockTitle,
    secrets,
    deletedSecrets,
    isDisabled,
  } = usePipelineSecrets()

  return (
    <>
      <SettingsBlock
        id="secrets"
        collapsible={secrets.length > 0 || isShowPipelineSecretForm}
        title={settingsBlockTitle}
        details={
          'Parameters whose actual values are stored securely by TeamCity and hidden away from web UI, logs, YAML configurations, and other locations'
        }
        collapsedNote={secrets
          .map(([_, name]) => name)
          .filter(name => !deletedSecrets?.includes(name))
          .join(', ')}
        onAddClick={handlerAddSecretButtonClick}
      >
        {secrets.map(([originalName, name]) => {
          const isDeleted = deletedSecrets?.includes(name)

          return (
            <PipelineSecret
              disabled={isDisabled}
              deleted={isDeleted}
              key={originalName}
              originalName={originalName}
            />
          )
        })}
        {isShowPipelineSecretForm && (
          <PipelineSecretForm
            onConfirm={handlerApplySecretButtonClick}
            onCancel={handlerCloseSecretButtonClick}
          />
        )}
      </SettingsBlock>
    </>
  )
}

export default memo(PipelineSecrets)
